export default "__VITE_ASSET__CYJi0I4___"